import { render, staticRenderFns } from "./WidgetEvents.vue?vue&type=template&id=794f1fbc"
import script from "./WidgetEvents.vue?vue&type=script&lang=js"
export * from "./WidgetEvents.vue?vue&type=script&lang=js"
import style0 from "./WidgetEvents.vue?vue&type=style&index=0&id=794f1fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports